import { useForm, FormProvider } from 'react-hook-form';
import { ErrorMessage } from '@hookform/error-message';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import clsx from 'classnames';
import { Card as MuiCard, Grid } from '@mui/material';
import { makeStyles } from '@mui/styles';
import ToggleButton from '@mui/lab/ToggleButton';
import { InputLabelBase } from '../../../../components/inputs/InputLabelBase';
import { RegisteredToggleButtonGroup } from '../../../../components/Buttons/registered/v7/RegisteredToggleButtonGroup';

const LabelProps = {
  required: true,
  TypographyProps: {
    variant: 'body2',
    gutterBottom: true,
  },
};

const schema = Yup.object().shape({
  renewalChangeInAnswers: Yup.bool()
    .required()
    .label('Change in Renewal Answers'),
});

const ChangeInRenewalForm = ({
  formId = 'ChangeInAccountForRenewalForm',
  ...props
}) => {
  const classes = useStyles();

  const toggleButtonProps = {
    disabled: false,
    // @ts-expect-error TS(2339): Property 'toggleButton' does not exist on type 'Cl... Remove this comment to see the full error message
    className: classes.toggleButton,
    classes: {
      // @ts-expect-error TS(2339): Property 'toggleButtonDisabled' does not exist on ... Remove this comment to see the full error message
      disabled: classes.toggleButtonDisabled,
    },
  };

  const { handleSubmit, ...methods } = useForm({
    resolver: yupResolver(schema),
  });

  function submission(formValues: any) {
    props.onSubmit(formValues);
  }

  return (
    <FormProvider {...methods} handleSubmit={handleSubmit}>
        <form id={formId} onSubmit={handleSubmit(submission)}>
          {/* @ts-expect-error TS(2769): No overload matches this call. */}
          <Grid container styles={classes.mainContainer}>
            <MuiCard style={{ width: '100%', paddingBottom: '2.083rem' }}>
              <div className="flex--spaced">
                {/* @ts-expect-error TS(2339): Property 'miniheading' does not exist on type 'Cla... Remove this comment to see the full error message */}
                <h3 className={clsx('contrast-text', classes.miniheading)}>
                  Renewal Question
                </h3>
              </div>

              <Grid item md={12}>
                {/* @ts-expect-error TS(2339): Property 'noPadding' does not exist on type 'Class... Remove this comment to see the full error message */}
                <InputLabelBase {...LabelProps} className={classes.noPadding}>
                  Besides revenue and employee count, have there been any
                  changes to account information or the security questions shown
                  above?
                </InputLabelBase>
                <RegisteredToggleButtonGroup
                  // @ts-expect-error TS(2339): Property 'toggleAlignment' does not exist on type ... Remove this comment to see the full error message
                  className={classes.toggleAlignment}
                  exclusive
                  name="renewalChangeInAnswers"
                >
                  <ToggleButton
                    form="ChangeInAccountForRenewalForm"
                    value
                    type="submit"
                    style={{ marginRight: '.044rem' }}
                    {...toggleButtonProps}
                  >
                    <div>Yes</div>
                  </ToggleButton>
                  <ToggleButton
                    form="ChangeInAccountForRenewalForm"
                    value={false}
                    type="submit"
                    {...toggleButtonProps}
                  >
                    <div>No</div>
                  </ToggleButton>
                </RegisteredToggleButtonGroup>
                <ErrorMessage
                  errors={methods.formState.errors}
                  name="renewalChangeInAnswers"
                  render={({ message }) => (
                    // @ts-expect-error TS(2339): Property 'error' does not exist on type 'ClassName... Remove this comment to see the full error message
                    <p className={classes.error}>{message}</p>
                  )}
                />
              </Grid>
            </MuiCard>
          </Grid>
        </form>
      </FormProvider>
  );
};

// @ts-expect-error TS(2345): Argument of type '({ config, palette }: DefaultThe... Remove this comment to see the full error message
const useStyles = makeStyles(({ config, palette }) => ({
  error: {
    color: `${config.colors.textRed} !important`,
    textAlign: 'center',
  },
  toggleAlignment: {
    display: 'flex',
    justifyContent: 'center',
    paddingTop: '0.83rem',
  },
  mainContainer: {
    direction: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    paddingTop: '2rem !important',
  },
  card: {
    padding: '1.6666666667rem',
    backgroundColor: palette.primary.greyCard,
    color: config.colors.white,
  },
  miniheading: {
    fontWeight: config.weights.bold,
    fontSize: '2.083rem',
    paddingLeft: '2.083rem',
    marginBottom: '0.875rem',
    marginTop: '0.875rem',
  },
  errorHandling: {
    textAlign: 'center',
    margin: 'auto',
    width: '50%',
  },
  noPadding: {
    paddingTop: '0px',
    paddingLeft: '2.083rem',
  },
  toggleButton: {
    backgroundColor: palette.common.cowbellBlue,
    borderColor: palette.primary.contrastText,
    '&:hover': {
      backgroundColor: palette.background.default,
    },
    padding: '0.5rem 4rem',
  },
  toggleButtonDisabled: {
    color: `${palette.primary.contrastText} !important`,
  },
  divider: {
    marginRight: '1.563rem',
  },
}));

export default ChangeInRenewalForm;
